import tenantsAPI from '../../../api/tenants'

const mapOrder = (order) => {
  switch (order) {
  case 'name':
    return 'name'
  case 'created':
    return 'created_at'
  default:
    return 'name'
  }
}

export default {
  async index({commit, state}, view) {
    commit('setFetchingForView', {view, value: true})

    const meta = state.views[view].meta

    const params = {}

    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    const resp = await tenantsAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit}, {id}) {
    const resp = await tenantsAPI.show({id})
    commit('setCurrent', resp.data.data)
  },

  async store({commit, state, dispatch}) {
    const data = {name: state.forms.store.fields.name, enable_bioreq: state.forms.store.fields.enableBioreq}
    let success = true

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    try {
      await tenantsAPI.store({data})
    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSuccess', success)
    commit('forms/store/setSaving', false)

    if (success) {
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, dispatch}, {id}) {
    const data = {name: state.forms.update.fields.name, enable_bioreq: state.forms.update.fields.enableBioreq}
    let success = true
    let resp

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/update/setSaving', true)

    try {
      resp = await tenantsAPI.update({id, data})
    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSuccess', success)
    commit('forms/update/setSaving', false)

    if (success) {
      dispatch('index', state._defaultView)
      commit('upsert', {view: state._defaultView, entity: resp.data.data})
      commit('setCurrent', resp.data.data)
    }
  },

  async restore({state, commit, dispatch}, id) {
    const data = { 'is_deleted': false }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await tenantsAPI.update({id, data})
    dispatch('index', state._archivedView)
    dispatch('index', state._defaultView)
  },

  async archive({state, commit, dispatch}, id) {
    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await tenantsAPI.destroy({id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tenants/actions.js